<template>
  <!-- 新aw -->
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick" style="width: 100%" v-show="!dialogVisible">
      <el-tab-pane label="微信扫码登录" name="first">
        <div class="secondLog">
          <div id="qrcode"></div>
          <p style="color: #b1b1b1">使用手机微信"扫一扫"扫码登录</p>
        </div>
        <div style="width: 70%; margin: auto">
          <el-divider></el-divider>

          <el-link type="warning" href="https://www.google.cn/chrome/" target="_blank" :underline="false">推荐使用Google
            Chrome浏览器访问</el-link>
        </div>
      </el-tab-pane>
      <el-tab-pane label="账号密码登录" name="second">
        <div class="secondLog">
          <el-input class="speace" placeholder="请输入账号" v-model="loginData.usercard" clearable></el-input>
          <el-input class="speace" placeholder="请输入密码" v-model="loginData.password" show-password clearable></el-input>
          <el-row class="speace">
            <el-col :span="14">
              <el-input placeholder="验证码(区分大小写)" v-model="valcode" clearable></el-input>
            </el-col>
            <el-col :span="10">
              <img id="valimage" @click="changeValimage()" />
            </el-col>
          </el-row>
          <el-button class="speace loginBtn" type="primary" :loading="loading"
            @click="login()">登&emsp;&emsp;&emsp;&emsp;录</el-button>
          <!-- <el-button type="text" @click="dialogVisible = true">点击打开 Dialog</el-button> -->
          <!-- <router-link to="home"><button>首页预览</button></router-link> -->
        </div>
        <div style="width: 70%; margin: auto">
          <el-divider></el-divider>

          <el-link type="warning" href="https://www.google.cn/chrome/" target="_blank" :underline="false">推荐使用Google
            Chrome浏览器访问</el-link>
        </div>
      </el-tab-pane>
    </el-tabs>

    <div class="secondLog changePsw" v-show="dialogVisible">
      <el-alert title="第一次登录请修改密码" type="warning" style="margin-bottom: 20px"></el-alert>

      <!-- <el-alert title="密码位数必须大于等于8位数，并且必须包含大写字母（ABC...Z）、小写字母（abc...z）、数字（012...9）、特殊符号（！@#$%^&*( ) ）四种类型" type="info" :closable="false"></el-alert> -->
      <el-form label-position="left" label-width="80px" :model="formData">
        <el-form-item label="旧密码">
          <el-input v-model="formData.oldpwd" show-password clearable></el-input>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input v-model="formData.newpwd" show-password clearable></el-input>
        </el-form-item>
        <el-form-item label="确认密码">
          <el-input v-model="formData.checkpwd" show-password clearable></el-input>
        </el-form-item>
      </el-form>
      <el-button class="speace loginBtn" type="primary" :loading="loading" @click="updatePassword()">确认修改密码</el-button>

      <el-divider></el-divider>

      <p>
        密码位数必须大于等于8位数，并且必须包含大写字母（ABC...Z）、小写字母（abc...z）、数字（012...9）、特殊符号（！@#$%^&*(
        ) ）四种类型
      </p>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {
      loginData: {
        usercard: "",
        password: "",
      },
      formData: {
        oldpwd: "",
        newpwd: "",
        checkpwd: "",
      },

      changePswMsg: "",
      loading: false,
      valcode: "",
      msg: "",
      dialogVisible: false,
      activeName: "first",
      codeFlag: "",
      userID: "",
    };
  },
  methods: {
    login() {
      this.loginData.usercard = this.loginData.usercard.trim();
      this.loginData.password = this.loginData.password.trim();
      this.valcode = this.valcode.trim();
      this.loading = true;
      console.log(this.loginData);
      idt.Login(this.loginData.usercard, this.loginData.password, this.valcode);
    },
    openWin() {
      this.$alert(this.msg, "错误提示", {
        confirmButtonText: "确定",
      });
      this.loading = false;
    },

    handleClose(done) {
      this.$confirm("第一次登录或长时间未登录请修改密码")
        .then((_) => {
          done();
        })
        .catch((_) => { });
    },
    updatePassword() {
      // var tokenData = idt.GetTokenParams();
      // this.userID = tokenData.id;

      idt.ChangePassword(
        this.formData.oldpwd,
        this.formData.newpwd,
        this.formData.checkpwd,
        this.loginData.usercard
      );

      // console.log(this.formData.oldpwd,this.formData.newpwd,this.formData.checkpwd)
    },
    changeValimage() {
      idt.GetValidateCode(60, 25, document.getElementById("valimage"));
      this.valcode = "";
    },
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    openWin(msg) {
      this.$alert(msg, "错误提示", {
        confirmButtonText: "确定",
      });
      this.loading = false;
    },

    //启动监听
    enterKeyup() {
      document.addEventListener("keyup", this.enterKey);
    },
    //监听回车
    enterKey() {
      let _self = this;
      document.onkeydown = function (e) {
        var key = window.event.keyCode;
        // if(key == 13 || key == 100){
        if (key == 13) {
          _self.login();
        }
      };
    },
    //销毁监听
    enterKeyupDestroyed() {
      document.removeEventListener("keyup", this.enterKey);
    },

  },
  mounted() {
    //在初始html后执行
    idt.onReady = function () {
      idt.CreateQRCode("qrcode", "200", "200");
      idt.GetValidateCode(60, 25, document.getElementById("valimage"));
    };
    idt.CreateQRCode("qrcode", "200", "200");
    idt.GetValidateCode(60, 25, document.getElementById("valimage"));
    var _this = this;

    idt.onLogin = function (res) {
      console.log(res);
      if (res.code == 50 || res.code == 60) {
        _this.changePswMsg = res.message;
        _this.codeFlag = res.code;

        //修改密码
        //注销账户 打开修改弹窗
        // idt.Logout();
        _this.dialogVisible = true;
        _this.changeValimage();
        _this.loading = false;
      } else if (res.code == 0) {
        // 正常登录
        _this.dialogVisible = false;
        // window.location.href = "/oa/#/UserDesktop";
        let tokeninfo = idt.GetTokenParams();
        console.log(tokeninfo.usertype)
        if (tokeninfo.usertype == 1) {
          window.location.href = "/oa/#/UserDesktop";
        } else {
          // window.location.href = '/o_auto/user/#/sso'
          idt.Jump("/oasys/user/#/sso");

        }
      } else {
        _this.dialogVisible = false;
        _this.changeValimage();
        _this.openWin(res.message);
        _this.loading = false;

        // idt.Jump("/oa/#/UserDesktop");
      }
    };
    // console.log(idt);

    const that = this;
    idt.onChangePassword = function (res) {
      //   console.log(res);
      //   console.log(_this.codeFlag);
      if (res.code == 0) {
        // _this.$message(res.message);
        _this.dialogVisible = false;
        if (_this.codeFlag == 50) {
          // 第一次登录修改密码需要重新输入账号密码
          _this.formData.oldpwd = "";
          _this.formData.newpwd = "";
          _this.formData.checkpwd = "";
          _this.loginData.password = "";
          _this.changeValimage();
          _this.$message({
            message: "修改密码成功，请重新登录",
            type: "success",
          });
        } else if (_this.codeFlag == 60) {
          // 久未登录修改密码直接跳转
          window.location.href = "/oa/#/UserDesktop";
        }
      } else {
        var msg = res.message;
        _this.$message({
          message: msg,
          type: "warning",
        });
      }
    };
    idt.onRefreshToken = function (res) {
      idt.Logout();
    };
    idt.onLogout = function (res) {
      // console.log(res)
      return false;
    };
  },
  created() {
    this.enterKeyup();
  },
  destroyed() {
    this.enterKeyupDestroyed();
  },
};
</script>
<style scoped>
.secondLog {
  width: 70%;
  margin: 30px auto 10px;
  height: 260px;
}

#valimage {
  width: 60%;
}

.changePsw>p {
  color: #bf3636;
  font-size: 14px;
  text-align: left;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}
</style>
<style>
.el-tabs__active-bar {
  background-color: #bf3636 !important;
}

.el-link.el-link--warning {
  color: #bf3636 !important;
}

.el-tabs__item {
  font-size: 16px !important;
}

.el-tabs__item.is-active,
.el-tabs__item:hover {
  color: #bf3636 !important;
  font-size: 16px !important;
}

.el-tabs__item {
  width: 250px !important;
}

.el-tabs__nav-wrap::after {
  height: 3px !important;
}

.el-tabs__active-bar {
  height: 3px !important;
}

.el-input__inner {
  width: 100% !important;
}

.el-input__inner:focus {
  border-color: #bf3636 !important;
}

.speace {
  margin: 15px 0px;
}

.loginBtn {
  width: 100%;
  background-color: #bf3636 !important;
  border-color: #bf3636 !important;
  /* letter-spacing:10px; */
  /* margin-top: 30px !important; */
  font-size: 14px !important;
}

#qrcode {
  padding-top: 15px;
}

#qrcode>img {
  margin: auto;
}
</style>